import { ECalendarsActions, WorkingTimeSchemaActions } from '../actions/calendars.actions';
import { CalendarsOperations } from './calendars-operation';

export const initialCalendarsState: ICalendarsState = {
  isLoadingBase: false,
  isLoadingCalendarsList: false,
  isLoadingUserCalendars: false,
  baseCalendar: {
    calendarByDays: [],
    calendarByRange: [],
    guidWorkingTimeSchema: '',
    wtsName: '',
    idWorkingTimeSchema: -1
  },
  calendarList: [],
  customUserCalendar: [],
  selectedUser: undefined,
  calendarsDict: {},
  toDelete: {},
  initialBaseCalendar: {
    calendarByDays: [],
    calendarByRange: [],
    guidWorkingTimeSchema: '',
    wtsName: '',
    idWorkingTimeSchema: -1
  },
  initialCustomUserCalendar: []
}

export function calendarsReducers(state = initialCalendarsState, action: WorkingTimeSchemaActions): ICalendarsState {
  switch (action.type) {
    case ECalendarsActions.CalendarsList: {
      const newState = {
        ...state,
        isLoadingCalendarsList: true
      };
      return newState;
    }

    case ECalendarsActions.CalendarsListSuccess: {
      const newState = {
        ...state,
        calendarList: [...action.payload],
        isLoadingCalendarsList: false
      };
      return newState;
    }

    case ECalendarsActions.GetBaseCalendar: {
      const newState = {
        ...state,
        isLoadingBase: true
      };
      return newState;
    }

    case ECalendarsActions.GetBaseCalendarSuccess: {
      const newState = {
        ...state,
        baseCalendar: { ...action.payload,
          calendarByDays: action.payload ? [...action.payload.calendarByDays] : [],
          calendarByRange: action.payload ? [...action.payload.calendarByRange] : []},
        isLoadingBase: false
      };
      return newState;
    }

    case ECalendarsActions.GetUserCalendar: {
      const newState = {
        ...state,
        isLoadingUserCalendars: true
      };
      return newState;
    }

    case ECalendarsActions.GetUserCalendarSuccess: {
      const calendarDic = CalendarsOperations.getCalendarDic(action.payload);
      const newState = {
        ...state,
        calendarsDict: { ...calendarDic },
        customUserCalendar: [...action.payload],
        isLoadingUserCalendars: false
      };
      return newState;
    }

    case ECalendarsActions.SetSelectedUser: {
      const newState = {
        ...state,
        selectedUser: action.payload
      };
      return newState;
    }

    case ECalendarsActions.SetBaseCalendarUser: {
      const newState = {
        ...state,
        baseCalendar: action.payload
      };
      return newState;
    }

    case ECalendarsActions.UpdateBaseCalendarUser: {
      const newState = {
        ...state,
        isLoadingBase: true
      };
      return newState;
    }

    case ECalendarsActions.UpdateBaseCalendarUserSuccess: {
      const newState = {
        ...state,
        isLoadingBase: false
      };
      return newState;
    }

    case ECalendarsActions.UpdateCustomCalendar: {
      const newState = {
        ...state,
        isLoadingUserCalendars: true
      };
      return newState;
    }

    case ECalendarsActions.UpdateCustomCalendarSuccess: {
      const newState = {
        ...state,
        isLoadingUserCalendars: false
      };
      return newState;
    }

    case ECalendarsActions.AddWorkingTimeSchema:
    case ECalendarsActions.ModifyWorkingTimeSchema:
    case ECalendarsActions.ResetWorkingTimeSchema: {
      const newState = {
        ...state,
        isLoadingUserCalendars: true
      }
      return newState;
    }

    case ECalendarsActions.ChangesOverWorkingTimeSchemaSuccess: {
      const calendarsDict = CalendarsOperations.getCalendarDic(action.payload);
      const toDelete = {};
      state.customUserCalendar.forEach((item) => {
        const exist = action.payload.find((newItem) => {
          return item.fromDate === newItem.fromDate && item.toDate === newItem.toDate
        });
        if (!exist && item.idWorkingTimeData >= 0) {
          toDelete[`${item.idWorkingTimeData}`] = true;
        }
      });
      const newState = {
        ...state,
        isLoadingUserCalendars: false,
        calendarsDict,
        toDelete,
        customUserCalendar: [...action.payload]
      }
      return newState;
    }

    case ECalendarsActions.SetCustomCalendar: {
      const newState = {
        ...state,
        customUserCalendar: action.payload
      };
      return newState;
    }

    case ECalendarsActions.DeleteWorkingTimeSchemaRange: {
      const toDeleteIndex = state.customUserCalendar.findIndex((schema) => {
        return action.payload.fromDate === schema.fromDate && action.payload.toDate === schema.toDate;
      });
      if (toDeleteIndex < 0) {
        return state;
      }
      const _workingTimeSchema = state.customUserCalendar.map((schema) => {
        return { ...schema };
      });
      const toDelete = {};
      if (_workingTimeSchema[toDeleteIndex].idWorkingTimeData >= 0) {
        toDelete[`${_workingTimeSchema[toDeleteIndex].idWorkingTimeData}`] = true;
      }
      _workingTimeSchema.splice(toDeleteIndex, 1);
      const newState = {
        ...state,
        toDelete: { ...state.toDelete, ...toDelete },
        customUserCalendar: [..._workingTimeSchema]
      };
      return newState;
    }

    case ECalendarsActions.SetInitialBaseCalendarUser: {
      const newState = {
        ...state,
        initialBaseCalendar: { ...action.payload,
          calendarByDays: action.payload ? [...action.payload.calendarByDays] : [],
          calendarByRange: action.payload ? [...action.payload.calendarByRange] : [] },
      };
      return newState;
    }

    case ECalendarsActions.SetInitialCustomCalendarUser: {
      const newState = {
        ...state,
        initialCustomUserCalendar: action.payload
      };
      return newState;
    }

    case ECalendarsActions.ResetState: {
      return initialCalendarsState;
    }

    default:
      return state;
  }
};
